import React, { FC } from 'react'
import Drawer from '@material-ui/core/Drawer'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { TreeNav } from '@components/std-components/TreeNav'
import { Menu } from '@components/std-components/Menu'
import Typography from '@components/std-components/Typography'
import classNames from 'classnames'

export const SIDEBAR_WIDTH = 200

const Sidebar = withStyles({
  paperAnchorLeft: {
    left: 'unset'
  },
  paper: {
    top: 'unset',
    width: SIDEBAR_WIDTH,
    zIndex: 998
  },
  paperAnchorDockedLeft: {
    borderRight: 'unset'
  }
})(Drawer)

const useStyles = makeStyles(theme => ({
  listWrapper: {
    overflow: 'auto',
    margin: '-22px 26px 0px 10px',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '&  > div::-webkit-scrollbar': {
      display: 'none'
    }
  },
  enhancedListWrapper: {
    height: '100%',
    margin: '0px 0px 0px 10px',
    '& .menu-list-independent:last-child': {
      paddingBottom: 5
    }
  },
  typographyMenuList: {
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  menuHierarchy: {
    '& > div': {
      padding: '0 30px 0 0'
    }
  },
  hierarchyNavMenu: {
    marginLeft: 0,
    height: '100%'
  },
  menuTitleClass: {
    marginTop: 0
  },
  fullHeightMenu: {
    height: '100%'
  }
}))

export interface HierarchyNavProps {
  title: string
  open: boolean
  hierarchy: any
  selected: string[]
  height: number
  onNavClick: (nodeId) => void
  scrollIndex: number
  hierarchyLoading: boolean
  isEnhancedViewEnabled?: boolean
  enhancedHeaderEnabled?: boolean
}

export const HierarchyNav: FC<HierarchyNavProps> = ({
  title,
  open,
  hierarchy,
  selected,
  height,
  onNavClick,
  scrollIndex,
  hierarchyLoading,
  isEnhancedViewEnabled,
  enhancedHeaderEnabled
}) => {
  const classes = useStyles({ isEnhancedViewEnabled })
  return (
    <Sidebar
      variant='persistent'
      open={open}
      transitionDuration={0}
      style={{ height }}
      className={isEnhancedViewEnabled ? classes.menuHierarchy : ''}
      PaperProps={{
        style: { height, background: isEnhancedViewEnabled ? 'white' : '#fbfbfb' }
      }}
    >
      <Menu
        menuTitle={
          title ? (
            <Typography
              variant='title'
              color={'primary'}
              classes={classes.typographyMenuList}
              decorator='plain'
            >
              {title}
            </Typography>
          ) : null
        }
        openState={open}
        menuTitleClass={classNames({
          [classes.menuTitleClass]: isEnhancedViewEnabled
        })}
        menuListClass={classes.hierarchyNavMenu}
        className={isEnhancedViewEnabled ? classes.fullHeightMenu : ''}
      >
        <div
          className={classNames(classes.listWrapper, {
            [classes.enhancedListWrapper]: isEnhancedViewEnabled
          })}
        >
          <TreeNav
            nodeList={hierarchy}
            selected={selected}
            height={height - (isEnhancedViewEnabled ? 10 : 33)}
            showOnlySelected={false}
            onNavClick={onNavClick}
            showSelectedIcon={true}
            scrollIndex={scrollIndex}
            showLoading={hierarchyLoading}
            isEnhancedViewEnabled={isEnhancedViewEnabled}
            enhancedHeaderEnabled={enhancedHeaderEnabled}
          />
        </div>
      </Menu>
    </Sidebar>
  )
}
